import React, { FC } from 'react';
import { HeroBannerProps, Styled } from '.';
import BannerSlides from './BannerSlides';
import { nanoid } from 'nanoid';
import { useWindowWidth } from 'utils/hooks';

const HeroBanner: FC<HeroBannerProps> = ({
  bannerSlides,
  isLoading,
  isError,
}) => {
  const isSingleBanner = bannerSlides?.length === 1;

  const clientWidth = useWindowWidth();

  const carouselOptions = {
    arrows: false,
    autoPlay: !isSingleBanner,
    autoPlaySpeed: 5000,
    containerClass: 'container',
    draggable: true,
    focusOnSelect: false,
    infinite: true,
    keyBoardControl: true,
    minimumTouchDrag: 80,
    pauseOnHover: true,
    ssr: true,
    shouldResetAutoplay: true,
    showDots: !isSingleBanner,
    slidesToSlide: 1,
    swipeable: true,
    responsive: {
      desktop: {
        breakpoint: {
          max: 3000,
          min: 1024,
        },
        items: 1,
      },
      mobile: {
        breakpoint: {
          max: 464,
          min: 0,
        },
        items: 1,
      },
      tablet: {
        breakpoint: {
          max: 1024,
          min: 464,
        },
        items: 1,
      },
    },
    // styled component props:
    $width: clientWidth,
  };

  if (isLoading) return null;
  if (isError) return null;
  if (!bannerSlides) return null;

  return (
    <>
      <Styled.CustomCarousel {...carouselOptions}>
        {bannerSlides?.map(slide => (
          <BannerSlides key={nanoid()} slideData={slide} />
        ))}
      </Styled.CustomCarousel>
    </>
  );
};

export default HeroBanner;
